import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eb368a4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "user-detail-layout"
}
const _hoisted_2 = {
  key: 0,
  class: "py-m"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Uložit změny ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Zrušit ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Editovat uživatele ")
const _hoisted_6 = { class: "mr-m" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Zakázat ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Povolit ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Resetovat heslo ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Odstranit uživatele ")

import BaseBox from '@/components/layout/BaseBox.vue';
import BaseFlex from '@/components/layout/BaseFlex.vue';
import UserRoleEditor from '@/components/UserRoleEditor.vue';
import { useRoute, useRouter } from 'vue-router';
import {
	NDescriptions,
	NDescriptionsItem,
	NButton,
	NInput,
	NForm,
	NFormItem,
	NAlert,
	useMessage,
	useDialog,
	FormRules,
	FormValidationError,
} from 'naive-ui';
import { API } from '@/api';
import { computed, h, onBeforeMount, reactive, ref, watch } from 'vue';
import BaseSpinner from '@/components/ui/BaseSpinner.vue';
import NotFoundContent from '@/components/NotFoundContent.vue';
import { useStore } from 'vuex';
import { getResponseMessage } from '@/utils';

interface Errors {
	first_name?: string;
	last_name?: string;
	username?: string;
	message?: string;
}
interface UserForm {
	first_name: string | null;
	last_name: string | null;
	username: string | null;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const successMessage = ref<string | undefined>();

const route = useRoute();
const userNotFound = ref<boolean>(false);
const formRef = ref();
const { push: pushRoute } = useRouter();
const { dispatch, getters } = useStore();
const userInfo = ref<User | undefined>();
const pending = ref<boolean>(false);
const isEditing = ref<boolean>(false);

const rights = computed(() => getters['auth/rights']);

const message = useMessage();
const dialog = useDialog();
const myInfo = computed(() => getters['auth/userInfo']);
const errors = reactive<Errors>({
	first_name: undefined,
	last_name: undefined,
	username: undefined,
	message: undefined,
});
const formModel = ref<UserForm>({
	first_name: null,
	last_name: null,
	username: null,
});

const rules = ref<FormRules>({
	first_name: [
		{
			required: true,
			message: 'Jméno je povinné',
			trigger: ['input', 'blur'],
		},
	],
	last_name: [
		{
			required: true,
			message: 'Příjmení je povinné',
			trigger: ['input', 'blur'],
		},
	],
	username: [
		{
			required: true,
			// message: 'Uživatelské jméno je povinné',
			validator(rule, value) {
				if (!value) {
					return new Error('Uživatelské jméno je povinné');
				}
				if (!new RegExp(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/, 'i').test(value)) {
					return new Error('Uživatelské jméno musí být email');
				}
				return true;
			},
			trigger: ['input', 'blur'],
		},
	],
});
const idUser = computed<string | undefined>(() =>
	typeof route.params.id === 'string' ? route.params.id : undefined
);
const setEditing = (): void => {
	formModel.value.first_name = userInfo.value?.first_name || null;
	formModel.value.last_name = userInfo.value?.last_name || null;
	formModel.value.username = userInfo.value?.username || null;
	isEditing.value = true;
};
const unsetEditing = (): void => {
	isEditing.value = false;
};

const fetchUser = async (): Promise<void> => {
	if (typeof idUser.value === 'undefined') {
		return;
	}
	userNotFound.value = false;

	if (!pending.value) {
		pending.value = true;
	}
	try {
		const userResponse = await API.users.getUser(idUser.value);

		if (typeof userResponse.payload === 'object' && userResponse.payload !== null) {
			userInfo.value = userResponse.payload as User;
		}
		pending.value = false;
	} catch (error) {
		const fetchError: AjaxResponseDto = error as AjaxResponseDto;

		if (
			typeof fetchError === 'object' &&
			fetchError !== null &&
			'payload' in fetchError &&
			typeof fetchError?.payload === 'object' &&
			fetchError?.payload !== null &&
			!Array.isArray(fetchError?.payload)
		) {
			if (fetchError?.payload?.code === 404) {
				userNotFound.value = true;
			} else if (typeof fetchError?.payload?.message === 'string') {
				message.error(fetchError?.payload?.message || 'Neznámá chyba načtení uživatele');
			} else {
				message.error('Neznámá chyba načtení uživatele');
			}
		}
		pending.value = false;
	}
};

const submitForm = async () => {
	if (!rights.value.admin) return;

	if (typeof userInfo.value?.id === 'undefined') {
		return;
	}
	successMessage.value = undefined;
	errors.first_name = undefined;
	errors.last_name = undefined;
	errors.message = undefined;
	if (formRef.value !== null && typeof formRef.value.validate === 'function') {
		await formRef.value.validate(async (validationErrors: FormValidationError) => {
			if (!validationErrors) {
				pending.value = true;
				try {
					await API.users.updateUser(userInfo?.value?.id || '', {
						first_name: formModel.value.first_name || '',
						last_name: formModel.value.last_name || '',
						username: (formModel.value.username || '').replace(/\s+/g, ''),
					});
					await fetchUser();
					unsetEditing();
					message.success('Uživatel byl úspěšně aktualizován');
					pending.value = false;
					await dispatch('users/fetchData', true);
					await dispatch('lists/fetchSalesPersons', true);
				} catch (error) {
					pending.value = false;
					const catchError: AjaxResponseDto = error as AjaxResponseDto;
					const { message: errorMessage, fields } = catchError?.payload as MessageResponseDto;

					if (typeof fields === 'object' && fields !== null && Object.keys(fields).length > 0) {
						Object.keys(fields).forEach((key) => {
							if (key === 'first_name' || key === 'last_name' || key === 'username') {
								errors[key] = fields[key];
							}
						});
					} else {
						errors.message = errorMessage || 'Neznámá chyba při vytváření uživatele';
					}
				}
			}
		});
	}
};

const deleteUser = async () => {
	if (!rights.value.admin) return;

	if (typeof idUser.value === 'undefined') {
		return;
	}

	if (myInfo.value.id === idUser.value) {
		return;
	}

	pending.value = true;

	try {
		const response: AjaxResponseDto = await API.users.deleteUser(idUser.value);
		const responseMessage: string | undefined = getResponseMessage(response);

		if (responseMessage) {
			message.success(responseMessage);
		}

		await dispatch('users/fetchData', true);
		await dispatch('lists/fetchSalesPersons', true);
		await pushRoute('/nastaveni/uzivatele');
	} catch (error) {
		const catchError: AjaxResponseDto = error as AjaxResponseDto;
		const responseMessage: string | undefined = getResponseMessage(catchError);
		if (responseMessage) {
			message.error(responseMessage);
		}
		pending.value = false;
	}
};

const resetUserPassword = async () => {
	if (!rights.value.admin) return;

	if (typeof idUser.value === 'undefined') {
		return;
	}
	if (myInfo.value.id === idUser.value) {
		return;
	}
	pending.value = true;
	try {
		const response: AjaxResponseDto = await API.users.resetPassword(idUser.value);
		const responseMessage: string | undefined = getResponseMessage(response);
		if (responseMessage) {
			message.success(responseMessage);
		}
		await fetchUser();
	} catch (error) {
		const catchError: AjaxResponseDto = error as AjaxResponseDto;
		const responseMessage: string | undefined = getResponseMessage(catchError);
		if (responseMessage) {
			message.error(responseMessage);
		}
		pending.value = false;
	}
};

const deleteUserPrompt = async () => {
	if (typeof idUser.value === 'undefined') {
		return;
	}
	if (myInfo.value.id === idUser.value) {
		return;
	}
	dialog.error({
		title: 'Odstranění uživatel',
		content: () =>
			h('div', [
				h('p', { style: { textAlign: 'center' } }, `Skutečně chcete odstranit tohoto uživatele?`),
				h(
					'div',
					{
						style: {
							fontWeight: 'bold',
							textAlign: 'center',
							paddingTop: '15px',
							paddingBottom: '15px',
						},
					},
					[
						h(
							'p',
							{ style: { fontSize: '18px' } },
							`${userInfo.value?.first_name} ${userInfo.value?.last_name}`
						),
						h('p', userInfo.value?.username),
					]
				),
			]),
		positiveText: 'Ano, odstranit',
		negativeText: 'Ne, ponechat',
		onPositiveClick: async () => {
			dialog.destroyAll();
			await deleteUser();
		},
		onNegativeClick: () => {
			dialog.destroyAll();
		},
	});
};

const resetPasswordPrompt = async () => {
	if (typeof idUser.value === 'undefined') {
		return;
	}
	if (myInfo.value.id === idUser.value) {
		return;
	}
	dialog.warning({
		title: 'Resetování hesla',
		content: () =>
			h('div', [
				h(
					'p',
					{ style: { textAlign: 'center' } },
					`Skutečně chcete resetovat heslo pro tohoto uživatele?`
				),
				h(
					'div',
					{
						style: {
							fontWeight: 'bold',
							textAlign: 'center',
							paddingTop: '15px',
							paddingBottom: '15px',
						},
					},
					[
						h(
							'p',
							{ style: { fontSize: '18px' } },
							`${userInfo.value?.first_name} ${userInfo.value?.last_name}`
						),
						h('p', userInfo.value?.username),
					]
				),
			]),
		positiveText: 'Ano, resetovat',
		negativeText: 'Ne, ponechat',
		onPositiveClick: async () => {
			dialog.destroyAll();
			await resetUserPassword();
		},
		onNegativeClick: () => {
			dialog.destroyAll();
		},
	});
};

const enableLogin = async () => {
	if (!rights.value.admin) return;

	if (typeof idUser.value === 'undefined') {
		return;
	}
	if (myInfo.value.id === idUser.value) {
		return;
	}
	pending.value = true;
	try {
		const response: AjaxResponseDto = await API.users.enableLogin(idUser.value);
		const responseMessage: string | undefined = getResponseMessage(response);
		if (responseMessage) {
			message.success(responseMessage);
		}
		await fetchUser();
		await dispatch('users/fetchData', true);
	} catch (error) {
		const catchError: AjaxResponseDto = error as AjaxResponseDto;
		const responseMessage: string | undefined = getResponseMessage(catchError);
		if (responseMessage) {
			message.error(responseMessage);
		}
		pending.value = false;
	}
};

const disableLogin = async () => {
	if (!rights.value.admin) return;

	if (typeof idUser.value === 'undefined') {
		return;
	}
	if (myInfo.value.id === idUser.value) {
		return;
	}
	pending.value = true;
	try {
		const response = await API.users.disableLogin(idUser.value);
		const responseMessage: string | undefined = getResponseMessage(response);
		if (responseMessage) {
			message.success(responseMessage);
		}
		await fetchUser();
		await dispatch('users/fetchData', true);
	} catch (error) {
		const catchError: AjaxResponseDto = error as AjaxResponseDto;
		const responseMessage: string | undefined = getResponseMessage(catchError);
		if (responseMessage) {
			message.error(responseMessage);
		}
		pending.value = false;
	}
};

onBeforeMount(async () => {
	await fetchUser();
});
watch(
	() => route.params.id,
	async (newVal, oldVal) => {
		if (typeof newVal === 'string' && newVal !== '' && newVal !== oldVal) {
			await fetchUser();
		}
	}
);

return (_ctx: any,_cache: any) => {
  return (userNotFound.value)
    ? (_openBlock(), _createBlock(NotFoundContent, {
        key: 0,
        status: "404",
        title: "Uživatel nenalezen",
        "redirect-link": "/nastaveni/uzivatele",
        "redirect-text": "Přejít na přehled uživatelů"
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(BaseFlex, {
          row: "",
          "row-gap": "15px",
          "col-gap": "15px",
          wrap: "wrap"
        }, {
          default: _withCtx(() => [
            _createVNode(BaseFlex, {
              col: "",
              "class-name": "user-basic-info"
            }, {
              default: _withCtx(() => [
                _createVNode(BaseBox, { title: "Základní informace" }, {
                  default: _withCtx(() => [
                    (isEditing.value)
                      ? (_openBlock(), _createBlock(_unref(NForm), {
                          key: 0,
                          ref_key: "formRef",
                          ref: formRef,
                          model: formModel.value,
                          rules: rules.value,
                          style: {"width":"100%"},
                          onSubmit: _withModifiers(submitForm, ["prevent"])
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "first_name",
                              label: "Jméno",
                              feedback: _unref(errors).first_name,
                              "validation-status": _unref(errors).first_name ? 'error' : undefined
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: formModel.value.first_name,
                                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formModel.value.first_name) = $event)),
                                  size: "large",
                                  placeholder: "Jméno",
                                  disabled: pending.value
                                }, null, 8, ["value", "disabled"])
                              ]),
                              _: 1
                            }, 8, ["feedback", "validation-status"]),
                            _createVNode(_unref(NFormItem), {
                              path: "last_name",
                              label: "Příjmení",
                              feedback: _unref(errors).last_name,
                              "validation-status": _unref(errors).last_name ? 'error' : undefined
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: formModel.value.last_name,
                                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formModel.value.last_name) = $event)),
                                  size: "large",
                                  placeholder: "Příjmení",
                                  disabled: pending.value
                                }, null, 8, ["value", "disabled"])
                              ]),
                              _: 1
                            }, 8, ["feedback", "validation-status"]),
                            _createVNode(_unref(NFormItem), {
                              path: "username",
                              label: "Email/uživatelské jméno",
                              feedback: _unref(errors).username,
                              "validation-status": _unref(errors).username ? 'error' : undefined
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: formModel.value.username,
                                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formModel.value.username) = $event)),
                                  size: "large",
                                  placeholder: "Uživatelské jméno",
                                  disabled: pending.value
                                }, null, 8, ["value", "disabled"])
                              ]),
                              _: 1
                            }, 8, ["feedback", "validation-status"]),
                            (_unref(errors).message)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                  _createVNode(_unref(NAlert), { type: "error" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(errors).message), 1)
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode(BaseFlex, {
                              justify: "center",
                              align: "center",
                              "col-gap": "5px",
                              "class-name": "py-m",
                              "row-gap": "15px",
                              "mobile-col": ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NButton), {
                                  type: "primary",
                                  size: "large",
                                  "attr-type": "submit",
                                  disabled: 
									!!(
										pending.value ||
										formModel.value.first_name === null ||
										formModel.value.first_name === '' ||
										formModel.value.last_name === null ||
										formModel.value.last_name === '' ||
										formModel.value.username === null ||
										formModel.value.username === ''
									)
								,
                                  loading: pending.value
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_3
                                  ]),
                                  _: 1
                                }, 8, ["disabled", "loading"]),
                                _createVNode(_unref(NButton), {
                                  type: "default",
                                  size: "large",
                                  "attr-type": "button",
                                  onClick: unsetEditing
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_4
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model", "rules", "onSubmit"]))
                      : (_openBlock(), _createBlock(_unref(NDescriptions), {
                          key: 1,
                          "label-placement": "top",
                          column: 1
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NDescriptionsItem), { label: "Jméno" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(userInfo.value?.first_name || ''), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(NDescriptionsItem), { label: "Příjmení" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(userInfo.value?.last_name || ''), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(NDescriptionsItem), { label: "Email/uživatelské jméno" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(userInfo.value?.username || ''), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })),
                    (!isEditing.value)
                      ? (_openBlock(), _createBlock(BaseFlex, {
                          key: 2,
                          row: "",
                          "class-name": "mt-m",
                          flex: [1, 1],
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NButton), {
                              size: "small",
                              type: "warning",
                              tertiary: "",
                              disabled: _unref(myInfo).id === _unref(idUser),
                              onClick: setEditing
                            }, {
                              default: _withCtx(() => [
                                _hoisted_5
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(NDescriptions), {
                      "label-placement": "top",
                      column: 1,
                      class: "mt-l"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NDescriptionsItem), { label: "Může se přihlásit" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_6, _toDisplayString(typeof userInfo.value?.can_login === 'boolean'
										? userInfo.value.can_login
											? 'Ano'
											: 'Ne'
										: ''), 1),
                            (typeof userInfo.value?.can_login === 'boolean' && userInfo.value.can_login)
                              ? (_openBlock(), _createBlock(_unref(NButton), {
                                  key: 0,
                                  size: "small",
                                  type: "error",
                                  tertiary: "",
                                  disabled: _unref(myInfo).id === _unref(idUser),
                                  onClick: disableLogin
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_7
                                  ]),
                                  _: 1
                                }, 8, ["disabled"]))
                              : (typeof userInfo.value?.can_login === 'boolean' && !userInfo.value.can_login)
                                ? (_openBlock(), _createBlock(_unref(NButton), {
                                    key: 1,
                                    size: "small",
                                    type: "success",
                                    tertiary: "",
                                    disabled: _unref(myInfo).id === _unref(idUser),
                                    onClick: enableLogin
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_8
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"]))
                                : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(BaseFlex, {
                      row: "",
                      "mobile-col": "",
                      justify: "space-between",
                      class: "pt-xl",
                      "col-gap": "20px",
                      "row-gap": "20px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NButton), {
                          size: "small",
                          type: "warning",
                          secondary: "",
                          disabled: _unref(myInfo).id === _unref(idUser),
                          onClick: resetPasswordPrompt
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_unref(NButton), {
                          size: "small",
                          type: "error",
                          secondary: "",
                          disabled: _unref(myInfo).id === _unref(idUser),
                          onClick: deleteUserPrompt
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (pending.value)
                  ? (_openBlock(), _createBlock(BaseSpinner, { key: 0 }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(BaseFlex, {
              col: "",
              "class-name": "user-roles"
            }, {
              default: _withCtx(() => [
                _createVNode(BaseBox, { title: "Oprávnění" }, {
                  default: _withCtx(() => [
                    (userInfo.value)
                      ? (_openBlock(), _createBlock(UserRoleEditor, {
                          key: 0,
                          "user-info": userInfo.value
                        }, null, 8, ["user-info"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
}
}

})